/**
 * Feeds the landed ground moves to their ground mark (passes/groundLanding.ts): wraps the Effects' event handling (as
 * fx/longMoves.ts does) and keeps each `skill` event that carries a ground point. No fx ids of its own.
 */
import { getSkill, type WorldEvent } from '@nine/shared';
import { landStamps } from '../groundMarkKit';
import { registerFx, type FxHost } from './registry';

registerFx([], (host) => {
  let wrapped = false;
  return {
    step: () => {
      if (wrapped) return;
      wrapped = true;
      const h = host as FxHost & { handle(ev: WorldEvent): void };
      const inner = h.handle.bind(h);
      h.handle = (ev: WorldEvent): void => {
        inner(ev);
        if (ev.type !== 'skill' || !('at' in ev) || !ev.at) return;
        const s = getSkill(ev.skillId);
        if (!s.ground) return;
        landStamps.push({ src: ev.srcId, skillId: s.id, x: ev.at.x, y: ev.at.y, r: s.aoe ?? 1, t: host.world.time });
        if (landStamps.length > 16) landStamps.shift();
      };
    },
  };
});
